import { Autocomplete, TextField } from "@mui/material";
import { SEA_PORT_TERMINALS_CACHE } from "app/cache/cacheSettings";
import useLocalStorageCache from "app/cache/useLocalStorageCache";
import { ITerminal } from "app/types/dataInterfaces";
import { TransportMode } from "app/types/enums";
import { AutocompleteOptions } from "app/types/interfaces";
import axios, { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";

interface PortAutocompleteProps {
    onValueChange: (value?: number) => void;
}

export const PortAutocomplete = ({ onValueChange }: PortAutocompleteProps) => {
    const [portTerminals, setPortTerminals] = useLocalStorageCache<ITerminal[] | []>(SEA_PORT_TERMINALS_CACHE.key, SEA_PORT_TERMINALS_CACHE.initialData, SEA_PORT_TERMINALS_CACHE.maxAge);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState<AutocompleteOptions[]>([])


    useEffect(() => {
        const getTerminalData = async () => {
            try {
                const url = `${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetAllTerminals`;
                const res: AxiosResponse<ITerminal[]> = await axios.get(url, { params: { primaryTransportMode: TransportMode.Sea }});
                setPortTerminals(res.data);
            } catch (err) {
                if (axios.isAxiosError(err)) {
                    console.error(err.response?.data.message);
                }
            }
        }

        if (portTerminals === SEA_PORT_TERMINALS_CACHE.initialData) {
            getTerminalData()
        }

    }, [portTerminals, setPortTerminals]);

    useEffect(() => {
        if (portTerminals) {
            const options: AutocompleteOptions[] = portTerminals.map((item) => ({
                id: item.terminalId,
                label: `${item.name}(${item.code}) ${item.countryCode}`
            }));
            setAutoCompleteOptions(options)
        }
    }, [portTerminals]);

    //Pass selected terminal id to parent component
    const handleValueChange = (value: AutocompleteOptions | null) => onValueChange(value?.id);

    return(
        <Autocomplete
            size="small"
            disablePortal
            options={autoCompleteOptions}
            onChange={(_, value) => handleValueChange(value)}
            sx={{ marginTop: 1 }}
            renderInput={(params) => <TextField {...params} label="Port" />}
        />
    );
}